module.exports = __webpack_public_path__ + "img/img_3@2x.ec1986fb.png";